import { render, staticRenderFns } from "./LeadCreateDicas.vue?vue&type=template&id=7b5aceaf&scoped=true&lang=pug"
import script from "./LeadCreateDicas.vue?vue&type=script&lang=js"
export * from "./LeadCreateDicas.vue?vue&type=script&lang=js"
import style0 from "./LeadCreateDicas.vue?vue&type=style&index=0&id=7b5aceaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b5aceaf",
  null
  
)

export default component.exports